<header id="header">

    <div class="container">

        <nav class="navbar navbar-default">
            <a class="navbar-brand" [routerLink]="[ data.URL_HOME ] | localize"><img
                    src="./assets/imagens/logo_branca.png"></a>

            <ul class="navbar-nav float-right">
                <li>
                    <a [routerLink]="[ data.URL_HOME ] | localize"><i class="fa fa-home mr-2"></i>Home</a>
                </li>
            </ul>

        </nav>

        <section id="intro">
            <div class="container">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-12 text-justify mt-3 mb-3">
                        <div *ngFor="let paragrafo of data.PARAGRAFOS">
                            <h4>{{ paragrafo.TEXTO }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>

</header>

<main>

    <section id="contato-landing">

        <div class="container">

            <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">

                <div class="row">
                    <div class="col-lg-12">
                        <h3 class="text-primary">{{ data.CADASTRO.TITULO }}</h3>
                    </div>
                </div>

                <div class="row">

                    <div class="col-lg-4">
                        <div class="control-group">
                            <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CADASTRO.CAMPO_NOME }}
                                    <small class="text-danger">*</small></label>
                                <input class="form-control form-control-sm" type="text" formControlName="formNome">

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.CADASTRO.VALIDATOR.NOME">
                                    <span class="text-danger"
                                        *ngIf="formGroup.get('formNome').hasError(validator.TYPE) && (formGroup.get('formNome').dirty || formGroup.get('formNome').touched) ">{{
                                        validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="control-group">
                            <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CADASTRO.CAMPO_EMAIL }}
                                    <small class="text-danger">*</small></label>
                                <input class="form-control form-control-sm" type="email" formControlName="formEmail">

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.CADASTRO.VALIDATOR.EMAIL">
                                    <span class="text-danger"
                                        *ngIf="formGroup.get('formEmail').hasError(validator.TYPE) && (formGroup.get('formEmail').dirty || formGroup.get('formEmail').touched) ">{{
                                        validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="control-group">
                            <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CADASTRO.CAMPO_TELEFONE }}</label>
                                <input class="form-control form-control-sm" type="text" formControlName="formTelefone"
                                    maxlength="18">

                                <!-- mask="(99) 99999-9999" -->

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.CADASTRO.VALIDATOR.TELEFONE">
                                    <span class="text-danger"
                                        *ngIf="formGroup.get('formTelefone').hasError(validator.TYPE) && (formGroup.get('formTelefone').dirty || formGroup.get('formTelefone').touched) ">{{
                                        validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>
                        </div>
                    </div>

                </div>

                <div class="row d-flex justify-content-center mt-4">
                    <div class="col-lg-4">
                        <div class="control-group">
                            <div class="form-group mb-0">
                                <button class="btn" type="submit" [disabled]="!formGroup.valid">{{ data.CADASTRO.BOTAO
                                    }}</button>
                            </div>
                        </div>
                    </div>
                </div>

            </form>

        </div>

    </section>

</main>

<footer>

    <div class="container">

        <div class="row text-center">
            <div class="col-md-12">
                <h4 class="text-white">
                    {{ data.FOOTER.REDE_SOCIAL.TITULO }}
                </h4>
            </div>
        </div>

        <div class="row d-flex justify-content-center text-center mt-2">

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.FOOTER.REDE_SOCIAL.FACEBOOK }}" target="_blank">
                    <i class="fab fa-facebook fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.FOOTER.REDE_SOCIAL.INSTAGRAM }}" target="_blank">
                    <i class="fab fa-instagram fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.FOOTER.REDE_SOCIAL.TWITTER }}" target="_blank">
                    <i class="fab fa-twitter fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.FOOTER.REDE_SOCIAL.LINKEDIN }}" target="_blank">
                    <i class="fab fa-linkedin fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.FOOTER.REDE_SOCIAL.YOUTUBE }}" target="_blank">
                    <i class="fab fa-youtube fa-2x text-white"></i>
                </a>
            </div>

        </div>

        <div class="row mt-5">
            <div class="col-md-12 text-center text-white">
                &copy; Copyright 2021 - <a class="text-white" href="http://www.sirius.co" target="_blank"><strong>Sirius
                        Software</strong></a>. {{ data.FOOTER.RODAPE.TITULO }}
            </div>
        </div>

    </div>

</footer>